export const coachKeys = {
  all: ['coach'] as const,
  notifications: (coachId?: string) =>
    [...coachKeys.all, 'notifications', coachId ?? null] as const,
  notificationPreferences: (coachId?: string) =>
    [...coachKeys.all, 'notification-preferences', coachId ?? null] as const,
};
